import DealList from "../pages/DealList"
import DealInfo from "../pages/DealInfo" 
import MyDealList from "../pages/MyDealList" 
import MyStakeList from "../pages/MyStakeList" 
import NotFound from "../pages/NotFound"

const routes =  [
  {
    path: "/",
    element: <DealList/>
  },
  {
    path: "/deal/:id",
    element: <DealInfo/>
  },
  {
    path: "/all_deals",
    element: <DealList/>
  },
  {
    path: "/my_deals",
    element: <MyDealList/>
  },
  {
    path: "/my_stakes",
    element: <MyStakeList/>
  },
  {
    path: "*",
    element: <NotFound/>
  }
];

export default routes;